import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCheckCircle } from 'react-icons/fa'; // Success icon
import './Clearform.css'; // Import styles if using external CSS

const ClearForm = ({ message = "Payment Successful!", redirectPath = "/home" }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(redirectPath, { replace: true });
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate, redirectPath]);

  return (
    <div className="payment-container">

      <div className="circular-button">
        <FaCheckCircle className="success-icon" />
      </div>

      <div className="success-message">
        {message}
      </div>

      <canvas className="confetti-canvas"></canvas>
    </div>
  );
};

export default ClearForm;
